<template>
  <v-dialog
    v-model="createDialog"
    persistent
    max-width="600px"
  >
  
    <v-card style="padding:50px;">
      <v-card-title>
        <span class="headline">{{modalTitle}}</span>
        <v-spacer></v-spacer>
        <v-icon @click="showModal = false">fa fa-times</v-icon>
      </v-card-title>
      <v-text-field 
        label="Author First Name"
        v-model="newAuthorFirstName"
      ></v-text-field>
      <v-text-field
        label="Another Last Name"
        v-model="newAuthorLastName"
      ></v-text-field>

      <v-btn small @click="createNewAuthor()" color="primary">Save</v-btn>
    </v-card>


    <v-snackbar v-model="snackbar" :timeout="5000">
      {{ "Sucessfully created! " }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import * as API from "./../../api";
export default {
  name: "CreateDialog",
  props: ["createDialog", "firstName", "lastName", "id", 'modalTitle'],
  data() {
    return {
      newAuthorFirstName: this.firstName,
      newAuthorLastName: this.lastName,
      showModal: true,
      snackbar: false
    };
  },
  methods: {
    createNewAuthor() {
      this.$api
        .post(API.endpoints.authors, {
          ID: this.id,
          FirstName: this.newAuthorFirstName,
          LastName: this.newAuthorLastName,
        })
        .then(() => {
          this.snackbar = true;
          this.showModal = false
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  watch: {
    showModal(newValue) {
      this.showModal = true;
      this.$emit("create-modal-visibility", newValue);
    },
  },
};
</script>
<style>
.dialog-custom {
    padding: 50px;
}
</style>